import { ScrapedContentType } from './scraped-content-type.js';

export const SCRAPED_CONTENT_METADATA_FIELDS = [
  '_id',
  'candidateId',
  'election',
  'type',
  'status',
  'addMethod',
  'error',
  'url',
  'isMostRecent',
  'createdAt',
  'updatedAt',
  '__v',
];

export interface ContentCorpusTag {
  sourceUrl: string;
  text: string;
  type: string;
}

export interface BodyTextPage {
  sourceUrl: string;
  content: string;
  originalContent?: string;
  summary?: string;
}

export interface ScrapedContentBody {
  bodyText: BodyTextPage[];
  contentCorpus: ContentCorpusTag[];
  imagePaths: unknown[];
  socialMediaLinks: unknown[];
  resolvedUrl: string;
}

export interface ScrapedContent {
  _id: string;
  candidateId: string;
  election?: string;
  type: ScrapedContentType;
  status: 'pending' | 'success' | 'error';
  addMethod?: 'auto' | 'manual';
  error?: unknown | null;
  url: string;
  isMostRecent?: boolean;
  content?: ScrapedContentBody;
  createdAt: string;
  updatedAt: string;
  __v: number;
}

export interface PatchScrapedContent {
  content?: ScrapedContentBody;
  addMethod?: 'auto' | 'manual';
  error?: unknown | null;
}
